import { PermissionsBaseModel } from '@fluxonos/features/user/models/permissions-base.model';
import { ManufacturerPermissionsEnum } from '@fluxonos/fluxonos-dto';

export class PermissionsManufacturerModel extends PermissionsBaseModel {
  public get canView(): boolean {
    const permissions = [ManufacturerPermissionsEnum.VIEW__FLUXONOS__MANUFACTURER];
    return this.checkPermissions(permissions);
  }

  public get canChange(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [ManufacturerPermissionsEnum.CHANGE__FLUXONOS__MANUFACTURER];
    return this.checkPermissions(permissions);
  }

  public get canAdd(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [ManufacturerPermissionsEnum.ADD__FLUXONOS__MANUFACTURER];
    return this.checkPermissions(permissions);
  }

  public get canDelete(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [ManufacturerPermissionsEnum.DELETE__FLUXONOS__MANUFACTURER];
    return this.checkPermissions(permissions);
  }

  public get isAdmin(): boolean {
    return this.canView && this.canChange && this.canAdd && this.canDelete;
  }
}
